import Spline from '@splinetool/react-spline';

const EraUI = () => {
  return (
    <Spline className="aud-spline" scene="https://prod.spline.design/GZ10VIFrsMS3rCJH/scene.splinecode" />
  );
}

export default EraUI;